export async function later(cb, timeout) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(cb());
    }, timeout);
  });
}

export async function until(condition, options = {}) {
  const { intervalMs = 100, timeoutMs = 10000, maxAttempts = 0 } = options;

  let remainingIntervals = (
    intervalMs > 0 && maxAttempts > 0 ? maxAttempts : timeoutMs / intervalMs
  );

  return new Promise((resolve, reject) => {
    async function tick() {
      if (remainingIntervals <= 0) {
        resolve(false);
      } else {
        remainingIntervals -= 1;
        try {
          if (await condition()) {
            resolve(true);
          } else {
            await later(tick, intervalMs);
          }
        } catch (e) {
          reject(e);
        }
      }
    }

    tick();
  });
}
